<template>
  <v-card class="screen-card-skeleton-loader">
    <div class="main-content px-4 py-3">
      <v-skeleton-loader type="text" />
      <div class="d-flex mb-4">
        <v-skeleton-loader
          class="year-and-author flex-grow-1 mr-4"
          type="text"
        />
        <v-skeleton-loader
          class="year-and-author flex-grow-1"
          type="text"
        />
      </div>
      <v-skeleton-loader type="paragraph" />
    </div>
    <div class="actions py-3 px-4">
      <v-skeleton-loader type="button" />
      <div class="d-flex">
        <v-skeleton-loader class="mr-2" type="button" />
        <v-skeleton-loader class="mr-2" type="button" />
        <v-skeleton-loader type="button" />
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'ScreenCardSkeletonLoader',
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.screen-card-skeleton-loader {
  .year-and-author {
    max-width: 100px;
  }

  .actions {
    display: flex;
    justify-content: space-between;

    border-top: 1px solid map-get($grey, 'lighten-2');
    background-color: map-get($grey, 'lighten-5');
  }
}
</style>
